const errmsg = state => {
    return (state && state.errmsg) || ''
}
const status = state => {
    return (state && state.status) || ''
}
const msgNo = state => {
    return (state && state.msgNo) || {}
}
const categoryList = state => {
    return (state && state.categoryList) || {}
}
const faqContentList = state => {
    return (state && state.faqContentList) || {}
}
const faqContentInfo = state => {
    return (state && state.faqContentInfo) || {}
}
const msgTextStatus = state => {
    return (state && state.msgTextStatus) || {}
}
const faqQuStatus = state => {
    return (state && state.faqQuStatus) || {}
}
const msgAttrStatus = state => {
    return (state && state.msgAttrStatus) || {}
}
const FaqHstQuList = state => {
    return (state && state.FaqHstQuList) || {}
}
const FaqHstMsg = state => {
    return (state && state.FaqHstMsg) || {}
}
const faqEvalStatus = state => {
    return (state && state.faqEvalStatus) || {}
}
const loadingNO = state => {
    return (state && state.loadingNO) || ''
}
const loadingCate = state => {
    return (state && state.loadingCate) || ''
}
const loadingFC = state => {
    return (state && state.loadingFC) || ''
}
const loadingInfo = state => {
    return (state && state.loadingInfo) || ''
}
const statusQu = state => {
    return (state && state.statusQu) || ''
}
const statusText = state => {
    return (state && state.statusText) || ''
}
const statusAttr = state => {
    return (state && state.statusAttr) || ''
}
const loadingHst = state => {
    return (state && state.loadingHst) || ''
}
const loadingHM = state => {
    return (state && state.loadingHM) || ''
}
const statusEval = state => {
    return (state && state.statusEval) || ''
}
const unknownStatus = state => {
    return (state && state.unknownStatus) || {}
}
const statusUnknown = state => {
    return (state && state.statusUnknown) || ''
}
const searchData = state => {
    return (state && state.searchData) || {}
}
const reportStatus = state => {
    return (state && state.reportStatus) || ''
}
const reporting = state => {
    return (state && state.reporting) || {}
}
const searching = state => {
    return (state && state.searching) || ''
}
const upmsgStatus = state => {
    return (state && state.upmsgStatus) || {}
}
const updatingms = state => {
    return (state && state.updatingms) || ''
}
const faqVersion = state => {
    return (state && state.faqVersion) || {}
}
const fvLoading = state => {
    return (state && state.fvLoading) || ''
}
export default {
    errmsg,
    status,
    msgNo,
    faqVersion,
    fvLoading,
    categoryList,
    faqContentList,
    faqContentInfo,
    faqQuStatus,
    msgTextStatus,
    msgAttrStatus,
    FaqHstQuList,
    FaqHstMsg,
    faqEvalStatus,
    loadingNO,
    loadingCate,
    loadingFC,
    loadingInfo,
    statusQu,
    statusText,
    statusAttr,
    loadingHst,
    loadingHM,
    statusEval,
    unknownStatus,
    statusUnknown,
    searchData,
    reportStatus,
    reporting,
    searching,
    upmsgStatus,
    updatingms,
}